import { observable, action } from 'mobx';
import initIntersectionObserver from '../lazyload';

// Item Store
export default class ItemStore {
  @observable html = '';
  @observable configuration = '';

  update(data) {
    if (data.html !== undefined) {
      this.html = data.html;
      initIntersectionObserver();
    } else if ((typeof data) === 'string') {
      this.html = data;
      initIntersectionObserver();
    }
  }

  @action
  fetch(url, pushState = false) {
    this.url = url;
    const $item = $('[data-item-detail]');
    if (pushState) {
      window.history.pushState(null, null, url);
    } else {
      window.history.replaceState(null, null, url);
    }

    $('[data-lang-link]').each(function() {
      if (!$(this).data('original')) {
        $(this).data('original', $(this).attr('href'));
      }
      if (url.includes('?')) {
        $(this).attr('href', `${$(this).data('original').split('?')[0]}?${url.split('?')[1]}`);
      } else {
        $(this).attr('href', $(this).data('original').split('?')[0]);
      }
    });

    $item.addClass('mask mask--light');

    // add a suffix to the url to prevent caching the json-content in browser history for the url
    let suffix = '';
    if (!url.includes('_ajax')) {
      if (url.includes('?')) {
        suffix = '&_ajax=1';
      } else {
        suffix = '?_ajax=1';
      }
    }
    return $.ajax({
      url: `${url}${suffix}`,
      method: 'GET',
      success: (data) => {
        if (url === this.url) {
          this.update(data);
          $item.removeClass('mask mask--light');
        }
      },
      error: () => {
        $item.removeClass('mask mask--light');
      },
    });
  }

  @action
  config(url, $elem, postData) {
    $elem.addClass('mask mask--light');

    $('[data-lang-link]').each(function() {
      if (!$(this).data('original')) {
        $(this).data('original', $(this).attr('href'));
      }
      if (url.includes('?')) {
        $(this).attr('href', `${$(this).data('original').split('?')[0]}?${url.split('?')[1]}`);
      } else {
        $(this).attr('href', $(this).data('original').split('?')[0]);
      }
    });

    // add a suffix to the url to prevent caching the json-content in browser history for the url
    let suffix = '';
    if (!url.includes('_ajax')) {
      if (url.includes('?')) {
        suffix = '&_ajax=1';
      } else {
        suffix = '?_ajax=1';
      }
    }
    return $.ajax({
      url: `${url}${suffix}`,
      method: 'POST',
      data: postData,
      success: (resp) => {
        this.configuration = resp;
        $elem.removeClass('mask mask--light');
      },
      error: () => {
        $elem.removeClass('mask mask--light');
      },
    });
  }
}
